import React, { useState, useEffect, ReactElement } from 'react';
import PanelTextWithHeader from '../../../atoms/panels/PanelTextWithHeader';
import EditableTextarea from '../../../atoms/EditableTextarea';
import { updateProfileDescription } from '../../../actions/profileActions';
import { useDispatch } from 'react-redux';
import { FONT_FAMILIES } from 'theme/material/constants';
import { getTextColor } from 'style';

interface IAboutMeProps {
  description: string;
  editable: boolean;
  isProcessing: boolean;
  themeDarkMode?: boolean;
}

const AboutMe = (props: IAboutMeProps): ReactElement => {
  /* maintain a state here and create a method to pass down as props to toggle the state
     to show the editable fields for updating the about myself data */

  const { description, editable, isProcessing, ...rest } = props;
  const [editAboutMe, setEditAboutMe] = useState<boolean>(false);
  const [aboutMe, setAboutMe] = useState<string>('');
  const dispatch = useDispatch();

  useEffect(() => {
    setAboutMe(description);
    return () => {
      setEditAboutMe(false);
    };
  }, [description]);

  const toggleEditable = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    e.preventDefault();
    setEditAboutMe(!editAboutMe);
  };

  const updateAboutMe = (value: string): void => {
    setAboutMe(value);
  };

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    dispatch(
      updateProfileDescription({
        description: aboutMe,
      })
    );
    toggleEditable(e);
  };

  const handleCancel = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    // need to clear the fields if user select cancel button
    toggleEditable(e);
    setAboutMe(description);
  };

  return (
    <div>
      {editAboutMe ? (
        <EditableTextarea
          className="profile__about-me"
          title="A little bit about myself"
          value={aboutMe}
          handleCancel={handleCancel}
          handleSubmit={handleSubmit}
          updateValue={updateAboutMe}
          id={'description'}
          minCount={50}
          placeholder="Let people know some fun facts about who you are and what you're into. Icebreakers for your dates!"
          customStyle={{ paddingBottom: 20 }}
          isProcessing={isProcessing}
          panelStyle="borderless"
          customTitleStyle={{
            fontWeight: 400,
            fontFamily: FONT_FAMILIES.secondary,
            lineHeight: '20px',
            letterSpacing: -0.2,
            ...getTextColor().DARK_4,
          }}
        />
      ) : (
        <PanelTextWithHeader
          // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
          className="profile__about-me"
          title="A little bit about myself"
          editable={editable}
          content={aboutMe}
          toggleEditable={toggleEditable}
          dataTestId="edit-desc-info"
          isProcessing={isProcessing}
          panelStyle="borderless"
          minCount={50}
          customTitleStyle={{
            fontWeight: 400,
            fontFamily: FONT_FAMILIES.secondary,
            lineHeight: '20px',
            letterSpacing: -0.2,
            ...getTextColor().DARK_4,
          }}
          {...rest}
        />
      )}
    </div>
  );
};

export default React.memo(AboutMe);
